import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { keys as localStorageKeys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

const MAX_DISMISSAL_COUNT = 2;

export const shouldShowOptOutOption = (): boolean => {
	const dismissalCount = getDismissalCount();
	return dismissalCount >= MAX_DISMISSAL_COUNT;
};

export const incrementDismissalCount = (): void => {
	const dismissalCount = getDismissalCount();
	if (dismissalCount < MAX_DISMISSAL_COUNT) {
		localStorage.setItem(
			localStorageKeys.INVITE_ON_LINK_INSERT_DISMISSAL_COUNT,
			(dismissalCount + 1).toString(),
		);
	}
};

const getDismissalCount = (): number => {
	const value = localStorage.getItem(localStorageKeys.INVITE_ON_LINK_INSERT_DISMISSAL_COUNT);
	return isNaN(parseInt(value)) ? 0 : parseInt(value);
};

export const isUserOptOut = (): boolean =>
	localStorage.getItemAsBoolean(localStorageKeys.INVITE_ON_LINK_INSERT_OPT_OUT);

export const setUserOptOutTrue = (): void =>
	localStorage.setItem(localStorageKeys.INVITE_ON_LINK_INSERT_OPT_OUT, 'true');
